import { getEngagementParameters } from './click-events';
import triggerEvent, { GAEventName, GAEventParameters } from './events';

export function initGlobalAnalyticEventHandler(): void {
    document.addEventListener( 'click', async ( event: MouseEvent ): Promise<void> => {
        if ( !event.target || !( event.target instanceof HTMLElement ) ) {
            return;
        }

        const target = event.target;

        if ( ( !( target instanceof HTMLButtonElement ) && !( target instanceof HTMLAnchorElement ) ) || !target.matches( '[data-ga-event]' ) ) {
            return;
        }

        const eventName = target.dataset.gaEvent;

        if ( !eventName ) {
            throw new Error( 'event name undefined' );
        }

        const engagementParams = getEngagementParameters( target );

        let eventParameters: GAEventParameters = {
            'engaged_label': engagementParams.label,
            'engaged_element': engagementParams.element,
            'engaged_group': engagementParams.group,
        };

        if ( engagementParams.target ) {
            eventParameters[ 'engaged_target' ] = engagementParams.label;
        }

        if ( target.dataset.gaEventParameters ) {
            const elementParams = JSON.parse( target.dataset.gaEventParameters || '{}' ) as GAEventParameters;
            eventParameters = Object.assign( {}, eventParameters, elementParams );
        }

        await triggerEvent( eventName as GAEventName, eventParameters );
    } );
}
